module.exports = __webpack_public_path__ + "static/media/cogwheel.2dbfd4ca.svg";